// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__nPrMU","content":"Modal_content__Irf0Y","close-icon":"Modal_close-icon__tRt0v","wrapper":"Modal_wrapper__V5jEQ"};